import FundDetailsTabRow from 'components/Pages/FundsCenter/FundDetails/FundDetailsTabRow';
import FundDetailsTabSkeleton from 'components/Pages/FundsCenter/FundDetails/FundDetailsTabSkeleton';
import AlertMessageBase from 'components/Generic/AlertMessageBase';
import useHelpers from 'hooks/helpers';
import { useI18n } from 'next-localization';
import usePayload from 'hooks/useFundDetailsRequestPayload';
import { useFetchAuthorisedCountriesTabDataQuery } from '@/store/fundDetails/services/fundDetailsApi';

const FundDetailsAuthorisedCountriesTab = () => {
  const { getErrorDictionary } = useHelpers();
  const { t } = useI18n();
  const {
    shareClass,
    language,
    countryCode,
    correlationFundRangeId,
    site,
    countryInvestors,
    literatureAuthorizations,
  } = usePayload();
  const { data, error, isLoading } = useFetchAuthorisedCountriesTabDataQuery(
    {
      shareClass,
      language,
      countryCode,
      correlationFundRangeId,
      site,
      countryInvestors: {
        ...countryInvestors,
        literatureAuthorization: literatureAuthorizations[0],
      },
    },
    {
      skip: !shareClass,
    }
  );

  const ComponentContent = () => {
    return (
      <table aria-label="Fund details authorised countries tab table" className="w-100">
        <thead hidden>
          <tr style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.3)' }}>
            <th scope="col">Fund authorised country name</th>
          </tr>
        </thead>
        <tbody>
          {data.content.jurisdictions.map((item, key) => (
            <tr key={key} style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.3)' }}>
              <td className="body-default py-4">{item.countryName}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <FundDetailsTabRow fullWidth className="mt-4">
      {isLoading ? (
        <FundDetailsTabSkeleton />
      ) : error ? (
        <AlertMessageBase type="error" title={t(getErrorDictionary(error))} />
      ) : data ? (
        <ComponentContent />
      ) : (
        <div className="body-default">{t('noResultsMessage')}</div>
      )}
    </FundDetailsTabRow>
  );
};

export default FundDetailsAuthorisedCountriesTab;
